import { Label } from '@/components/ui/label';
import { FileUpload } from '@/components/ui/file-upload';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Image } from 'lucide-react';
import type { WizardFormData } from '../types';
import type { SchoolOptions } from '@/types/school';

interface BrandingStepProps {
  formData: WizardFormData;
  onChange: (data: Partial<WizardFormData>) => void;
  options: SchoolOptions | null;
  onRefreshOptions?: () => Promise<void>;
}

export function BrandingStep({ formData, onChange }: BrandingStepProps) {
  return (
    <div className="space-y-6 max-w-5xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-xl font-semibold text-foreground">Branding</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Personnalisez l'apparence de la plateforme
        </p>
      </div>

      <div className="grid gap-6">
        {/* Images */}
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-base">
              <Image className="h-4 w-4 text-primary" />
              Images
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid gap-6 grid-cols-1 max-w-xs">
              <div className="space-y-2">
                <Label>Logo principal</Label>
                <FileUpload
                  value={formData.logoFile}
                  onChange={(file) => onChange({ logoFile: file })}
                  label="Logo"
                  description="Affiché sur la plateforme"
                  maxSize={5 * 1024 * 1024}
                />
              </div>
            </div>
            <p className="text-xs text-muted-foreground mt-4">
              Les images supplémentaires (logo connexion, favicon, couverture) seront disponibles lorsque les marques blanches seront activées.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
